export const GET_MESSAGE_CONTENT_REQUEST = 'GET_MESSAGE_CONTENT_REQUEST';
export const GET_MESSAGE_CONTENT_SUCCESS = 'GET_MESSAGE_CONTENT_SUCCESS';
export const GET_BOPIS_HOLIDAY_MESSAGE_CONTENT_REQUEST =
    'GET_BOPIS_HOLIDAY_MESSAGE_CONTENT_REQUEST';
export const GET_BOPIS_HOLIDAY_MESSAGE_CONTENT_SUCCESS =
    'GET_BOPIS_HOLIDAY_MESSAGE_CONTENT_SUCCESS';
